const uid = function(){
    const now = Date.now().toString(36);

    const typedArray = new Uint32Array(1);
    const randomNum = crypto.getRandomValues(typedArray)[0] / Math.pow(2, 32);
    const rand = randomNum.toString(36).substring(2);

    return 'uid' + now + rand;
}
export default uid;
